import { DEVICE_TYPE } from 'b2b-components/utils/device';
import { State } from 'b2b-apps/shop/common/redux/types';
import {
  SettingsCatalogType,
  SettingsProductsCompareType,
  SettingsState,
} from 'b2b-apps/shop/settings/redux/types';

const getState = (state: State): SettingsState => state.settings;

const getDeviceType = (state: State): DEVICE_TYPE => getState(state).deviceType;

const getCatalogSettings = (state: State): SettingsCatalogType => getState(state).catalog;

const getProductsCompareSettings = (state: State): SettingsProductsCompareType => getState(state).productsCompare;

export {
  getCatalogSettings,
  getDeviceType,
  getProductsCompareSettings,
  getState,
};
